import Vue from 'vue'
import QrcodeVue from 'qrcode.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import components from './widgets'


components.forEach(component => {
  Vue.component(component._key, component)
})

Vue.component('QrcodeVue', QrcodeVue)
Vue.use(ElementUI, {
	size: 'small'
});



// WEBPACK FOOTER //
// ./src/components/index.js